import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import Loader from "storybookComponents/Loader";
import { getPropertyId } from "common";
import Expansion from "components/Expansion";
import styles from "../styles";
import UserContext from "context/UserContext";
import { saveSetting } from "../apis";
import { isEmail } from "../utils";
import BCCListComponent from "./bccList";
import RightContent from "../components/rightSection";

const BccList = ({
  classes,
  approverSettings,
  orgLevel,
  updateEventsSettings,
  showNotification,
}) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [expanded, setExpanded] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [bccList, setBccList] = React.useState([]);
  const [validate, setValidate] = React.useState(false);

  const handleExpandedPanel = () => setExpanded(!expanded);

  const handleBccList = (data) => setBccList(data);

  const validation = () => {
    for (const item of bccList) {
      if (!isEmail(item)) return false;
    }
    return true;
  };

  const handleSave = () => {
    let inputData = {
      orgId: subOrgDetails.org.id,
      approvalRequired: approverSettings.approvalRequired,
      approverEmails: approverSettings.approverEmails,
      agentApprovalEmails: approverSettings.agentApprovalEmails,
      hyeventsBccEmails: bccList,
    };
    if (!orgLevel) inputData["propertyId"] = getPropertyId();

    setIsLoading(true);
    saveSetting(inputData)
      .then((data) => {
        updateEventsSettings(data);
        setIsLoading(false);
        showNotification("Universal BCC is updated!", "success");
      })
      .catch((err) => {
        console.log("Error", err);
        showNotification(err?.message || "Something went wrong!", "error");
        setIsLoading(false);
      });
  };

  const renderRightContent = (open) => {
    if (open) return null;
    return <RightContent classes={classes} list={bccList} />;
  };

  const renderHeaderIcon = (open) => {
    if (open) return null;
    return <div className={classes.numberWrapper}>{bccList.length}</div>;
  };
  const handleResetClick = () => setBccList(approverSettings.hyeventsBccEmails);

  React.useEffect(() => {
    setValidate(validation());
  }, [bccList]);

  React.useEffect(() => {
    if (!!approverSettings) {
      setIsLoading(false);
      setBccList(approverSettings.hyeventsBccEmails);
    }
  }, [approverSettings]);
  return (
    <div className={classes.contentBox}>
      {isLoading && <Loader />}
      {!isLoading && (
        <Expansion
          handleExpandedPanel={handleExpandedPanel}
          expanded={expanded}
          header="Universal BCC"
          headerIcon={renderHeaderIcon}
          rightSection={renderRightContent}
        >
          <BCCListComponent
            classes={classes}
            bccList={bccList}
            handleBccList={handleBccList}
            handleSave={handleSave}
            state={
              validate && bccList.join() !== approverSettings?.hyeventsBccEmails.join()
                ? "active"
                : "inactive"
            }
            handleResetClick={handleResetClick}
          />
        </Expansion>
      )}
    </div>
  );
};

export default withStyles(styles)(BccList);
